import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { checkArray, checkNull } from "../../../helpers";
import { changeSettingValue, getClusterSettings } from "../../../Redux/actions";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";

const ClusterSettings = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { cluster_details } = useSelector((state) => state.settingReducer);

  useEffect(() => {
    dispatch(getClusterSettings());

    return () => {
      dispatch(changeSettingValue("cluster_details", null));
    };
  }, []);

  const [clusterSearch, setClusterSearch] = useState("");

  const clusterSearchHandler = (cluster) => {
    let resp = true;
    if (checkNull(clusterSearch, false)) {
      let searchText = clusterSearch.toLowerCase();
      resp = false;
      if (
        checkNull(cluster?.id.toString(), false) &&
        cluster?.id.toString().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(cluster?.cluster_name, false) &&
        cluster?.cluster_name.toLowerCase().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(cluster?.user?.full_name, false) &&
        cluster?.user?.full_name.toLowerCase().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(cluster?.total_stores.toString(), false) &&
        cluster?.total_stores.toString().includes(searchText)
      ) {
        resp = true;
      }
    }
    return resp;
  };

  const editClusterHandler = (cluster) => {
    dispatch(changeSettingValue("selected_cluster_details", cluster));
    history.push("/settings/add-cluster");
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0">
          <div className="container px-0">
            <div className="top-header-sec pt-3">
              <h3 className="event-alert br-btm-0"> Cluster List</h3>
              <div class="row-fluid">
                <div class="row justify-content-between align-items-center w-100 mx-0">
                  <form className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                    <div class="search-box mt-0">
                      <input
                        type="text"
                        placeholder="Search"
                        name="keyword"
                        id="CompanySearchTag"
                        autocomplete="off"
                        value={clusterSearch}
                        onChange={(e) =>
                          setClusterSearch(e?.target?.value ?? "")
                        }
                      />
                      <input type="button" />
                    </div>
                  </form>{" "}
                  <div class="col-sm-7 col-12 align-right px-0">
                    <div class="field text-right">
                      <button
                        class="btn green-btn-revert add-plus mx-0"
                        type="button"
                        onClick={() => history.push("/settings/add-cluster")}
                      >
                        <i class="i-icon"> </i> Add Cluster
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mx-0 px-0">
            <div className="container px-0 d-flex">
              <div className="shadowclass py-0">
                <div className="table-responsive">
                  <table className="checklist-table remove-space inventory_table m-0">
                    <thead>
                      <tr>
                        <th width="">Cluster ID</th>
                        <th width="">Cluster Name</th>
                        <th width="">Cluster Manager</th>
                        <th width=""># of Stores</th>
                        <th width=""> Actions </th>
                      </tr>
                    </thead>
                    <tbody>
                      {checkArray(cluster_details?.clusters) &&
                        cluster_details?.clusters
                          .filter((item) => clusterSearchHandler(item))
                          .map((cluster) => {
                            return (
                              <tr>
                                <td class="invent-first-col">{cluster?.id}</td>
                                <td>{cluster?.cluster_name}</td>
                                <td>{cluster?.user?.full_name}</td>
                                <td>{cluster?.total_stores}</td>
                                <td
                                  width="15px"
                                  class="invent-first-col no-min"
                                >
                                  <a
                                    class="circle_icon editApFinance"
                                    onClick={() => editClusterHandler(cluster)}
                                  >
                                    <i class="iconSprites edit-icon">
                                      <div class="tooltip-sm"> Edit </div>
                                    </i>
                                  </a>
                                </td>
                              </tr>
                            );
                          })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default ClusterSettings;
